import React, { Component } from 'react';
import { connect } from 'react-redux';
import './form.css';

class riskForm extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
     
    };

  }

  onChangeName = (event) =>{
    var tmpData = {...this.props.data};
    tmpData.name = event.target.value;
    tmpData.type = "RISK";
    tmpData.contractId = this.props.id;
    this.props.onUpdateData(tmpData);
  }

  onChangeType = (event) =>{
    var tmpData = {...this.props.data};
    tmpData.riskType = event.target.value;
    tmpData.type = "RISK";
    tmpData.contractId = this.props.id;
    this.props.onUpdateData(tmpData);
  }


  render() {
    var data = this.props.data;
    if(data === null){
      data = {type:"RISK",name:"",riskType:"type1",contractId:this.props.id};
    }

    return (
      <div className="form-container" >
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (contract id : {this.props.id})</span>
            <div className="section-status unvalid"></div>
          </div>
          <div className="section-item">
            <label>Name</label>
            <input type="text" onChange={this.onChangeName.bind()} value={data.name}></input>
          </div>
          <div className="section-item">
            <label>Type</label>
            <select onChange={this.onChangeType.bind()} value={data.riskType}>
              <option value="type1">risk type 1</option>
              <option value="type2">risk type 2</option>
            </select>
          </div>
        </div>
        <div className="form-section">
            <div className="section-header">
              <span className="section-name">Valeurs</span>
              <div className="section-status unvalid"></div>
            </div>
            <div className="section-item">
              <label>Schedule number</label>
              <input type="number"></input>
            </div>
          </div>
      </div>
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(riskForm);